export const reTranslateModuleNames = (moduleParsed: string): string => {
		const moduleNames = {
			'Dashboard': 'DASHBOARD',
			'Tempo Real': 'REAL_TIME',
			'Usuários': 'USER',
			'Empresa': 'COMPANY_SERVICE_PROVIDER',
			'Inventário': 'INVENTORY',
			'Plantio': 'PLANTING',
			'Avaliação': 'APPRAISAL',
			'Manejo': 'OPERATION_SERVICE',
			'Região': 'REGION',
			'Central de Controle': 'CENTRAL_CONTROL',
			'Configuração de avaliações': 'APPRAISAL_CONFIGURATION',
			'Configuração de manejo': 'MANAGEMENT_CONFIGURATION',
			'Operaçao de campo': 'OPERATION_FIELD'
		}

		return moduleNames[moduleParsed]
	}
